import React from 'react'
import * as R from 'ramda'

interface UseModalOptions {
  isInitiallyToggled?: boolean
}

interface UseModalReturn {
  isOpen: boolean
  handleClose: () => void
  handleOpen: () => void
}

export const useModal = ({
  isInitiallyToggled = false,
}: UseModalOptions = {}): UseModalReturn => {
  const [isOpen, setIsOpen] = React.useState(isInitiallyToggled)

  const handleClose = React.useCallback(() => setIsOpen(R.F), [setIsOpen])

  const handleOpen = React.useCallback(() => setIsOpen(R.T), [setIsOpen])

  return {
    isOpen,
    handleClose,
    handleOpen,
  }
}
